// 收藏数据存储键名
const FAVORITE_KEY = 'user_favorites';

// 获取所有收藏
export function getFavorites() {
    const favorites = localStorage.getItem(FAVORITE_KEY);
    return favorites ? JSON.parse(favorites) : [];
}

// 添加收藏
export function addFavorite(favoriteItem) {
    const favorites = getFavorites();
    favorites.push(favoriteItem);
    localStorage.setItem(FAVORITE_KEY, JSON.stringify(favorites));
}

// 移除收藏
export function removeFavorite(accountId, promotionId, materialId) {
    let favorites = getFavorites();
    favorites = favorites.filter(fav =>
        !(fav.accountId === accountId &&
            fav.promotionId === promotionId &&
            fav.materialId === materialId)
    );
    localStorage.setItem(FAVORITE_KEY, JSON.stringify(favorites));
}
